var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 59,
    viewBox: "0 0 64 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0205 51.9387H59.8679C61.0339 51.9387 62 53.1239 62 54.5274C62 55.9309 61.0339 57.1161 59.8679 57.1161H4.13215C2.99944 57.1161 2 55.9309 2 54.5274C2 53.1239 2.96613 51.9387 4.13215 51.9387H6.13103",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5717 7.7128L52.8382 7.43209L55.037 5.06171C55.57 4.46912 55.5034 3.56463 54.8704 3.06561L53.9709 2.34826C53.3379 1.81804 52.3718 1.91161 51.8388 2.5042L49.4401 5.12409L46.9748 7.80636L9.52894 48.4146C9.06254 48.9449 9.09584 50.785 10.2952 50.9098C12.7605 50.9098 25.5201 50.5043 35.4812 39.9624C41.2447 33.8805 43.2768 26.1456 40.0453 22.7772C39.6788 22.3717 39.6788 21.7791 40.0453 21.3736L50.1397 10.4263L52.5717 7.7128Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory4);
export default __webpack_public_path__ + "static/media/category4.7278ca45ca7d2b9eb41495b17908b265.svg";
export { ForwardRef as ReactComponent };